import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/our-chat/concept_back.webp";

function Ideabehind() {
  return (
    <section
      className="idea_behind idea_chat p-100 text_chat"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_chat_img">
              <StaticImage
                src="../../../images/case-studies/our-chat/concept.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={554}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              The Concept Behind <span>OurChat</span>
            </h1>
            <p>
              Whether you're seeking advice from a therapist, guidance from a
              financial advisor, or support from a career coach, OurChat offers
              a platform where you can connect with a range of professionals and
              experts in different fields. Our client wanted the app to be
              designed while keeping user convenience in mind. This is why its
              user-friendly interface allows you to search for and connect with
              professionals in seconds, while our advanced messaging system
              ensures that you can communicate with them seamlessly and
              securely.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
